import { v4 as uuidv4 } from 'uuid';
var UserSessionHelper = /** @class */ (function () {
    function UserSessionHelper() {
    }
    UserSessionHelper.initUserSession = function () {
        try {
            var COOKIE_NAME = "correlationId";
            // @ts-ignore
            var cookies = new URLSearchParams(document.cookie.replaceAll("&", "%26").replaceAll("; ", "&"));
            if (!cookies.get(COOKIE_NAME)) {
                var correlationId = "ltweb-" + uuidv4();
                var topDomain = window.location.hostname.split('.').slice(-2).join('.');
                document.cookie = COOKIE_NAME + "=" + correlationId + "; domain=" + topDomain + "; path=/; secure=true; SameSite=Lax";
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    return UserSessionHelper;
}());
export { UserSessionHelper };
export default UserSessionHelper;
